<template>
  <div>
    <!-- breadcrumb start -->
    <breadcrumb-one
      banner_height="page-banner-height-2"
      title="Your Cart"
      subtitle="Cart"
      :banner="'/assets/images/banner/page-banner-4.jpg'"
    ></breadcrumb-one>
    <!-- breadcrumb end -->

    <!-- cart area start -->
    <cart-area></cart-area>
    <!-- cart area end -->

    <!-- cta area start -->
    <cta-area></cta-area>
    <!-- cta area end -->
  </div>
</template>

<script>
import BreadcrumbOne from '@/components/breadcrumb/breadcrumb-one.vue';
import CartArea from '@/components/cart/cart-area.vue';
import CtaArea from '@/components/cta/cta-area.vue';
export default {
  name: "CartPage",
  components: {
      BreadcrumbOne,
      CartArea,
      CtaArea
    },
  metaInfo() {
    return {
      title: "Cart - Duka Market",
    };
  },
};
</script>
